import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 重置 ");

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 添加 ");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 编辑 ");

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 禁用 ");

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 启用 ");

import { ref } from 'vue';
import { dateFormat, getVexTableProps } from '@/config';
import { getAppStarupConfigureList, updateAppSratupStatus, delAppStarup } from '@/request';
import { ElMessage, ElMessageBox } from 'element-plus';
import AddStarUpPageModal from './component/AddStarUpPageModal.vue';
export default {
  name: 'AppStarUpConfigure',

  setup(__props) {
    const form = ref({
      activityName: '',
      activityStatus: '',
      startTime: '',
      endTime: ''
    });
    const table = ref();
    const showAddModal = ref(false);
    const editData = ref(null);
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '状态',
        field: 'statusText',
        width: '100px'
      }, {
        title: '活动状态',
        field: 'realTimeStatus',
        width: '200px'
      }, {
        title: '接收团队',
        field: 'supplierNames',
        width: '200px',
        showOverflow: true,
        formatter: ({
          cellValue
        }) => cellValue || '全部团队'
      }, {
        title: '活动名称',
        field: 'activityName',
        width: '200px'
      }, {
        title: '启用图片',
        slots: {
          default: 'previewImg'
        },
        width: '100px'
      }, {
        title: '跳转地址',
        field: 'targetUrl',
        width: '200px'
      }, {
        title: '开始时间',
        field: 'startTime',
        width: '200px'
      }, {
        title: '结束时间',
        field: 'endTime',
        width: '200px'
      }, {
        title: '更新时间',
        field: 'lastModifyTime',
        width: '250px'
      }, {
        title: '创建人',
        field: 'register',
        width: '150px'
      }, {
        title: '操作',
        fixed: 'right',
        width: '200px',
        slots: {
          default: 'operation'
        }
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getAppStarupConfigureList(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value)).then(data => {
              if (data.success) {
                const statusObj = {
                  1: '启用',
                  2: '禁用'
                };
                const rows = data.rows.map(row => {
                  row.statusText = statusObj[row.activityStatus];
                  return row;
                });
                res({
                  total: data.total,
                  result: rows
                });
              }
            });
          })
        }
      },
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      }
    });

    function reset() {
      form.value = {
        activityName: '',
        activityStatus: '',
        startTime: '',
        endTime: ''
      };
      table.value.commitProxy('reload');
    }

    function edit(row) {
      editData.value = row;
      showAddModal.value = true;
    }

    function addSuccess() {
      table.value.commitProxy('reload');
      showAddModal.value = false;
    }

    function updateStatus(row, status) {
      const {
        activityId,
        startTime,
        endTime,
        supplierIds,
        supplierFlag
      } = row;
      updateAppSratupStatus({
        _warn: true,
        __repeat: true
      }, {
        params: {
          activityId,
          activityStatus: status,
          startTime,
          endTime,
          supplierIds,
          supplierFlag
        }
      }).then(data => {
        if (data.success) {
          table.value.commitProxy('reload');
          return true;
        }

        ElMessage.error(data.message);
      });
    }

    function add() {
      showAddModal.value = true;
      editData.value = null;
    }

    function del() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      ElMessageBox.confirm(`是否确认删除${selectRows.length}条数据`, {
        title: '删除'
      }).then(() => {
        delAppStarup({
          __warn: true,
          __repeat: true
        }, {
          params: {
            activityIdS: selectRows.map(row => row.activityId).join(',')
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            table.value.commitProxy('query');
          }
        });
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_image = _resolveComponent("el-image");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
        "label-width": "80px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "活动名称"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.activityName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.activityName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "状态"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.activityStatus,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.activityStatus = $event),
                placeholder: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), _createVNode(_component_el_option, {
                  label: "启用",
                  value: "1"
                }), _createVNode(_component_el_option, {
                  label: "禁用",
                  value: "2"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "开始时间"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.startTime,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.startTime = $event),
                type: "date",
                "value-format": _unref(dateFormat),
                placeholder: "开始时间"
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "结束时间"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                type: "date",
                modelValue: form.value.endTime,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.endTime = $event),
                "value-format": _unref(dateFormat),
                placeholder: "结束时间"
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: _cache[4] || (_cache[4] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          icon: "CirclePlus",
          type: "primary",
          onClick: add
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          icon: "Delete",
          type: "danger",
          onClick: del
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]),
        previewImg: _withCtx(({
          row
        }) => [_createVNode(_component_el_image, {
          style: {
            "width": "70px",
            "height": "70px"
          },
          src: row.picUrl,
          "preview-src-list": [row.picUrl],
          fit: "cover"
        }, null, 8, ["src", "preview-src-list"])]),
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          icon: "Edit",
          type: "primary",
          onClick: $event => edit(row)
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 2
        }, 1032, ["onClick"]), row.activityStatus === '1' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "warning",
          onClick: $event => updateStatus(row, 2)
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 2
        }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "success",
          onClick: $event => updateStatus(row, 1)
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 2
        }, 1032, ["onClick"]))]),
        _: 1
      }, 16), _createVNode(AddStarUpPageModal, {
        modelValue: showAddModal.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => showAddModal.value = $event),
        onSuccess: addSuccess,
        editData: editData.value
      }, null, 8, ["modelValue", "editData"])]);
    };
  }

};